import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function PerfilamientoAdvisoryPage() {
  const { processId } = useParams()
  const { t } = useTranslation('perfilamiento')

  return (
    <section className="flex flex-col gap-4">
      <h1 className="m-0 text-[1.375rem] font-bold text-[var(--color-text-primary)]">
        {t('placeholder.advisory.title')}
      </h1>
      <div className="rounded-2xl border border-[var(--color-border-soft,#d9e0e7)] bg-white p-6 text-sm leading-6 text-[var(--color-text-muted)] shadow-[0_10px_30px_rgba(5,20,31,0.05)]">
        <p className="m-0">{t('placeholder.advisory.description')}</p>
        <p className="mt-3 mb-0">
          Process ID: <span className="font-medium text-[var(--color-text-primary)]">{processId ?? 'actual'}</span>
        </p>
      </div>
    </section>
  )
}
